import { useMemo } from 'react';
import { Typography } from 'antd';
import { SmartDataTableProps } from '@src/components/SmartDataTable/types';
import { useUserTimestampRender } from '@src/hooks';

const { Text } = Typography;

export const useBranchesColumns = (): SmartDataTableProps['columns'] => {
  const userTimestampRender = useUserTimestampRender({
    size: 'small',
  });

  return useMemo(
    () => [
      {
        key: 'id',
        title: 'ID',
        dataIndex: 'id',
        sorter: true,
        minWidth: 50,
        ellipsis: true,
        render: (value: any) => (
          <Text
            style={{
              fontSize: '12px',
              color: '#8c8c8c',
              backgroundColor: '#f5f5f5',
              padding: '2px 6px',
              borderRadius: '4px',
            }}
          >
            #{value}
          </Text>
        ),
      },
      {
        key: 'name',
        title: 'Name',
        dataIndex: 'name',
        sorter: false,
        minWidth: 200,
        render: (name: string) => (
          <Text style={{ fontWeight: 500, color: '#262626' }}>{name}</Text>
        ),
      },
      {
        key: 'user_timestamp',
        title: 'User & Timestamp',
        dataIndex: 'user_info',
        sorter: false,
        minWidth: 200,
        render: (value: any, record: any) => userTimestampRender(record),
      },
    ],
    [userTimestampRender]
  );
};
